/**
 * Whether Search (the ⌘K palette) is open, and the words it opens with. The
 * shell's ⌘K, the rail's Search row and a Team page's "Search every Team"
 * open it; the palette closes it.
 */
import { useSyncExternalStore } from "react";

export interface SearchState {
  open: boolean;
  /** The words the palette starts from (a Team page's search that found nothing there). */
  query: string;
}

let state: SearchState = { open: false, query: "" };
const listeners = new Set<() => void>();

function set(next: SearchState) {
  state = next;
  for (const listener of listeners) listener();
}

export const searchStore = {
  getSnapshot: (): SearchState => state,
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  open(query = "") {
    set({ open: true, query });
  },
  close() {
    if (state.open || state.query) set({ open: false, query: "" });
  },
};

export function useSearchState(): SearchState {
  return useSyncExternalStore(searchStore.subscribe, searchStore.getSnapshot);
}
